var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('main',[_c('article',{staticClass:"row"},[_c('section',{staticClass:"col s12"},[_c('h4',{staticClass:"red-text text-accent-3"},[_c('strong',[_vm._v("Page Not Found ")]),_c('span',{staticStyle:{"font-size":"40px"}},[_vm._v("😓")])])])])])
}]

export { render, staticRenderFns }